import { gql } from "apollo-boost";
import { getUsers } from 'components/graphql/queries';
import OnlyAdmin from 'components/guards/OnlyAdmin';
import OnlyHost from 'components/guards/OnlyHost';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import * as JSCookie from 'js-cookie';
import { RolesSystem } from 'lib/enums/RolesSystem.enum';
import DecayCenter from 'pages/manage/events/detail/DecayCenter';
import React from 'react'
import { Subscription } from "react-apollo";
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Card, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input } from 'reactstrap';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from 'stores/ducks/User.duck';

import { ContentLoader } from '../../../../components/common/loader/ContentLoader';
import { decay } from '../../../../components/graphql/queries/ticket';
import { StatusBadge } from '../../../../components/misc/StatusBadge/StatusBadge';
import { openModal } from '../../../../components/modal/modules/dispatcher/methods';

import { AppConfig } from '../../../../config/app';

import ResendForm from './ResendForm'


class Orders extends React.Component<
    { [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props)
        this.runSearch = this.runSearch.bind(this);
        this.executeSearch = this.executeSearch.bind(this);
        this.openDecayModal = this.openDecayModal.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.decayTicket = this.decayTicket.bind(this);
        this.countTicketPrice = this.countTicketPrice.bind(this);
        this.sort = this.sort.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.state = {
            tickets: [],
            isLoadingTickets: true,
            searchTerm: '',
            results: [''],
            resultFound: false,
            termChanged: false,
            loadFirst: true,
            newEmail: '',
            updateString: 0,
            updateString1: 0,
            updateString2: 0,
            updateString3: 0,
            filterDropdownOpen: false
        }
    }

    public componentDidMount() {
        fetchGraphQL(
            `
            query {
                ticket {
                    getByEventIdAsString(eventId:"${this.props.eventId}")
                }
            }
            `
        ).then(ress => {
            const tickets = ress !== null && ress.ticket != null ? JSON.parse(ress.ticket.getByEventIdAsString) : [];
            this.setState({ tickets, isLoadingTickets: false, loading: false });
        }); // End of tickets fetch

    }

    public toggleFilter() {
        this.setState({
            filterDropdownOpen: !this.state.filterDropdownOpen
        })
    }

    public countTicketPrice(ticketComponent: any[]) {

        if (ticketComponent === null) {
            return 0;
        }
        let totalPrice = 0;
        ticketComponent.map(titem => {
            totalPrice +=
                titem.count * titem.price;
        });

        return totalPrice;
    }

    public executeSearch() {
        if (this.state.searchTerm === '') {
            return
        }
        this.setState({ isLoadingEvent: true })
        fetchGraphQL(
            `
            {
              ticket {
                search(searchTerm:"${this.state.searchTerm}", eventId:"${this.props.eventId}") 
              }
            }
            `,
            undefined
        ).then(result => {

            const promoterNameSearchResults: any[] = []
            this.state.tickets.map(item => {
                if (item.promoterId !== undefined && item.promoterId !== null) {
                    if (this.props.promMap && this.props.promMap[item.promoterId] !== undefined) {
                        const name = (this.props.promMap[item.promoterId].name).toLowerCase().split(" ").join("");
                        if (name.search(this.state.searchTerm.toLowerCase().split(" ").join("")) === -1) {
                            // Do nothing ...
                        } else {
                            promoterNameSearchResults.push(item.code);
                        }
                    }
                }
            })

            const res = [...result.ticket.search, ...promoterNameSearchResults]

            if (res.length !== 0) {
                this.setState({ isLoadingEvent: false, resultFound: true, result: res, termChanged: false })
            } else {
                this.setState({ isLoadingEvent: false, resultFound: true, result: [''], termChanged: false })
            }
        })
    }

    // The below function doe not really run search -> It only sets the search term to the state 
    public runSearch(e: any) {

        // Empty search - not worth the effort
        if (e.target.value === '') {
            this.setState({ searchTerm: '', resultFound: false, result: [''], loadFirst: false, termChanged: true })
            return;
        }
        this.setState({ searchTerm: e.target.value, loadFirst: false, resultFound: false, termChanged: true })
    }
    public openDecayModal() {
        const content = <DecayCenter onClose={() => closeModal()}
            eventId={this.props.eventId}
            ticketInventory={this.props.ticketInventory}
            promMap={this.props.promMap} />

        openModal(content, 'Void Tickets ', [
        ]);

    }

    public resendEmail() {
        console.log('')
    }

    public decayTicket(code: string, index: number) {
        // optimistic update
        this.setState({ isLoadingTickets: true, loading: true })

        fetchGraphQL(decay(), undefined, {
            code,
        }).then(res => {
            fetchGraphQL(
                `
                query {
                    ticket {
                        getByEventIdAsString(eventId:"${this.props.eventId}")
                    }
                }
                `
            ).then(ress => {
                const tickets = ress.ticket != null ? JSON.parse(ress.ticket.getByEventIdAsString) : [];
                this.setState({ tickets, isLoadingTickets: false, loading: false });
            }); // End of tickets fetch
        });
    }

    public onSubmit(e: any) {
        console.log('')
    }

    public sort(by: string) {
        switch (by) {
            case ('customer'):
                break;
            case ('status'):
                break;
            case ('price'):
                break;
            case ('promoter'):
                break;
            case ('note'):
                break;
            case ('id'):
                break;
        }
    }

    public openDetailModal(ticketArg: any) {
        const modalTitle = 'Details';
        fetchGraphQL(
            `
    	    query {
      	        ticket {
        	        get(ticketCode:"${ticketArg.code}") {
                        code,
          	            status,
          	            promoterId,
          	            promoter{name,lastName}
		                note,
                        totalCount,
                        tax,
          	            totalPrice, 
          	            totalPlatformFees,
          	            totalProcessingFees,
                        ticketComponents{ticketBankId, count, price},
          	            buyer{fullName, email, phoneNumber},
                        boughtAt
                        refunded
                        chargeId
        	        }
      	        }
    	    }
		`
        ).then(ress => {
            const ticket = ress.ticket != null ? ress.ticket.get : ticketArg;
            fetchGraphQL(getUsers(), JSCookie.get("token"), {
                ids: [ticket.promoterId]
            }).then((res) => {
                const tax = ticket.tax ? ticket.tax : 0;
                const content = (
                    <div>
                        <div style={{ maxHeight: '620px', overflowY: 'scroll' }}>
                            <div className='p-2'>
                                <p key={'ti-' + ticket.code}>
                                    <strong className="sexyBlack">Name: </strong>{ticket.buyer.fullName}<br />
                                    <strong className="sexyBlack">Email: </strong>{ticket.buyer.email}<br />
                                    {
                                        this.props.eventId === '5e28bddffb65960ef12149a0' || this.props.eventId === '5deea257f2fad353eed0e822' ?
                                            <div>
                                                <strong className="sexyBlack">Color choice: </strong>{ticket.buyer.phoneNumber}<br />
                                            </div>
                                            : null
                                    }
                                    {
                                        this.props.eventId === '5e8048057a3aa10ea99480bc' ?
                                            <div>
                                                <strong className="sexyBlack">Mailing Address: </strong>{ticket.buyer.phoneNumber}<br />
                                            </div>
                                            : null
                                    }
                                    <strong className="sexyBlack">Ticket ID: </strong>{ticket.code}<br />
                                    <strong className="sexyBlack">Status: </strong>{ticket.status}<br />
                                    {
                                        res !== undefined && res.user !== undefined && ticket.promoterId !== undefined && ticket.promoterId! == null
                                            ? <div><strong>Promoter: </strong>{res.user.findByIds[0].name + ' ' + res.user.findByIds[0].lastname}<br /></div>
                                            : null
                                    }
                                    <br />
                                    <strong className="sexyBlack">Quantity: </strong>{ticket.totalCount}<br />
                                    <strong className="sexyBlack">Subtotal: </strong>
                                    {
                                        this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
                                    }
                                    {((ticket.totalPrice - ticket.totalPlatformFees - ticket.totalProcessingFees) / 100).toFixed(2)}<br />
                                    <strong className="sexyBlack">Tax: </strong>
                                    {
                                        this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
                                    }
                                    {(tax / 100).toFixed(2)}<br />
                                    <OnlyAdmin>
                                        <strong className="sexyBlack">Service charge: </strong>
                                        {
                                            this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
                                        }
                                        {(ticket.totalPlatformFees / 100).toFixed(2)}<br />
                                        <strong className="sexyBlack">Card processing fees: </strong>
                                        {
                                            this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
                                        }
                                        {(ticket.totalProcessingFees / 100).toFixed(2)}<br />
                                    </OnlyAdmin>
                                    <strong className="sexyBlack">Total price with fees (and taxes): </strong>
                                    {
                                        this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
                                    }
                                    {((ticket.totalPrice + tax) / 100).toFixed(2)}<br />
                                    <br />
                                    <strong className="sexyBlack">Time of purchase: </strong>
                                    <Moment format="M.D.Y">
                                        {ticket.boughtAt}
                                    </Moment>
                                    {" at "}
                                    <Moment format="hh:mm A">
                                        {ticket.boughtAt}
                                    </Moment>
                                    <br />
                                    {ticket.note !== null ? <div><strong className="sexyBlack">Note: </strong>{ticket.note || '-'}<br /></div> : null}
                                </p>
                            </div>
                        </div>
                        <div className='p-1'>
                            {
                                this.props.payoutDone || !this.props.isHostOrAdmin ? null :
                                    <div>
                                        <div style={{ width: '100%', textAlign: 'center', justifyContent: 'center' }}>
                                            <div>
                                                {
                                                    ticket.refunded !== undefined && ticket.refunded === true ?
                                                        <button disabled={true} className="new-button-white-3" style={{ border: 'none' }}>
                                                            REFUNDED
                                                        </button>
                                                        :
                                                        <button className="new-button-white-3" style={{ border: 'none' }} onClick={e => {
                                                            fetchGraphQL(`
                                                                mutation {
                                                                    ticket {
                                                                        refundOrVoid(code:"${ticket.code}")
                                                                    }
                                                                }
                                                            `).then(response => {
                                                                closeModal();
                                                                this.setState({
                                                                    timer: Date.now()
                                                                }, () => {
                                                                    while (true) {
                                                                        if (Date.now() - this.state.timer < 1250) {
                                                                            // Wait
                                                                        } else {
                                                                            break;
                                                                        }
                                                                    }
                                                                    window.location.reload();
                                                                })
                                                            })
                                                        }}>
                                                            {
                                                                ticket.totalPrice === 0 ? 'VOID' : 'REFUND'
                                                            }
                                                        </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                            }
                            <h5 className="sexyBlack" style={{ paddingTop: '20px' }}>Resend Ticket Order</h5>
                            <p style={{ fontSize: '11px' }}>
                                <br />The receipt for this ticket order can be re-sent to any email address. However, the ticket order can only be checked-in once.<br />
                            </p>
                        </div>
                        <div style={{
                            width: "100%",
                            textAlign: "center"
                        }}
                            className='p-2'
                        >
                            <ResendForm code={ticket.code} />
                        </div>
                        <p><br /><br /></p>
                        <div className="align-center" style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                            <button
                                className="new-button-white-3"
                                onClick={e => closeModal()}
                                style={{ border: 'none', cursor: 'pointer' }}
                            >
                                CANCEL
							</button>
                        </div>

                    </div>
                );
                openModal(content, modalTitle);
            })
        });
    }

    public reloadData(e: any, num: number) {
        fetchGraphQL(
            `
            query {
                ticket {
                    getByEventIdAsString(eventId:"${this.props.eventId}")
                }
            }
            `
        ).then(ress => {
            const tickets = ress.ticket != null ? JSON.parse(ress.ticket.getByEventIdAsString) : [];
            if (num === 1) {
                this.setState({ tickets, isLoadingTickets: false, loading: false, updateString: e });
            } else if (num === 2) {
                this.setState({ tickets, isLoadingTickets: false, loading: false, updateString1: e });
            } else if (num === 3) {
                this.setState({ tickets, isLoadingTickets: false, loading: false, updateString2: e });
            } else {
                this.setState({ tickets, isLoadingTickets: false, loading: false, updateString3: e });
            }
        });
        return undefined;
    }

    public render() {

        const { eventId } = this.props
        let unfilteredTickets: any[];

        unfilteredTickets = this.state.tickets.sort((a, b) => {
            if (a.updatedAt > b.updatedAt) { return -1; }
            if (a.updatedAt < b.updatedAt) { return 1; }
        });

        let tickets: any[] = [];
        if (this.state.resultFound && this.state.result[0] !== '') {
            tickets = unfilteredTickets.filter((item) => {
                return this.state.result.includes(item.code)
            })
        } else if (!this.state.resultFound) {
            tickets = unfilteredTickets;
        }

        const ticketPurchase = gql`
            subscription {
                ticketPurchase(eventIds:"${eventId}")
            }
        `;

        const ticketDecayed = gql`
            subscription {
                ticketDecayed(eventIds:"${eventId}")
            }
		`;

        const ticketCheckin = gql`
            subscription {
                ticketCheckin(eventIds:"${eventId}")
            }
		`;

        const ticketActivation = gql`
            subscription {
                ticketActivated(eventIds:"${eventId}")
            }
        `;

        const currency = this.props.currency ? this.props.currency : 'USD'

        return (
            <Card>
                <div>
                    <Subscription subscription={ticketPurchase}>
                        {({ data }) => {
                            if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                                if (data.ticketPurchase !== this.state.updateString) {
                                    return <img height={0} width={0} onLoad={this.reloadData(data.ticketPurchase, 1)} style={{ display: 'none' }} />
                                }
                                return null;
                            }
                            return null;
                        }}
                    </Subscription>
                    <Subscription subscription={ticketActivation}>
                        {({ data }) => {
                            if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                                if (data.ticketPurchase !== this.state.updateString1) {
                                    return <img height={0} width={0} onLoad={this.reloadData(data.ticketPurchase, 2)} style={{ display: 'none' }} />
                                }
                                return null;
                            }
                            return null;
                        }}
                    </Subscription>
                    <Subscription subscription={ticketDecayed}>
                        {({ data }) => {
                            if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                                if (data.ticketPurchase !== this.state.updateString2) {
                                    return <img height={0} width={0} onLoad={this.reloadData(data.ticketPurchase, 3)} style={{ display: 'none' }} />
                                }
                                return null;
                            }
                            return null;
                        }}
                    </Subscription>
                    <Subscription subscription={ticketCheckin}>
                        {({ data }) => {
                            if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                                if (data.ticketPurchase !== this.state.updateString3) {
                                    return <img height={0} width={0} onLoad={this.reloadData(data.ticketPurchase, 4)} style={{ display: 'none' }} />
                                }
                                return null;
                            }
                            return null;
                        }}
                    </Subscription>
                    <p />
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <h3 className={this.props.onSale ? 'sexyBlack' : 'pause-gray'}>Orders</h3>
                    </div>
                    <p />
                    <ContentLoader isLoading={this.state.isLoadingTickets}>
                        <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                            <div style={{ width: screen.width > 768 ? '50%' : '85%' }}>
                                <p />
                                <div>
                                    <div style={{ width: '80%', float: 'left' }}>
                                        <Input
                                            autoFocus={!this.state.loadFirst}
                                            disabled={this.state.loading}
                                            type="text"
                                            name="search"
                                            id="search"
                                            placeholder="🔍"
                                            // style={{  }}
                                            style={{ backgroundColor: '#ebecf1', borderRadius: '10px', height: '27px', fontSize: '15px', paddingRight: '4px', maxWidth: '350px' }}
                                            value={this.state.searchTerm}
                                            onChange={(e) => {
                                                e.preventDefault();
                                                this.runSearch(e);
                                            }}
                                        />
                                    </div>
                                    <div style={{ width: '17%', float: 'right' }}>
                                        {
                                            this.state.loading ? null :
                                                <div
                                                    className='new-button-white-4'
                                                    onClick={e =>
                                                        this.executeSearch()
                                                    }
                                                >
                                                    SEARCH
                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                        <p />
                        <div className="big-split-995">
                            <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>

                                <div
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div
                                        className='new-button-white-3'
                                        onClick={e =>
                                            this.openDecayModal()
                                        }
                                    >
                                        VOID TICKETS
                                    </div>
                                </div>

                                <OnlyHost eventId={this.props.eventId}>
                                    <div
                                        style={{ cursor: 'pointer', marginLeft: '15px' }}
                                    >
                                        <Dropdown
                                            isOpen={this.state.filterDropdownOpen}
                                            toggle={this.toggleFilter}
                                            className="new-button-white-3"
                                            onClick={e => this.toggleFilter()}
                                            style={{ cursor: 'pointer' }}>
                                            <DropdownToggle
                                                tag="span"
                                                onClick={e => this.toggleFilter()}
                                                data-toggle="dropdown"
                                                aria-expanded={this.state.filterDropdownOpen}
                                                caret={true}
                                            >
                                                REPORTS
                                            </DropdownToggle>
                                            <DropdownMenu style={{ borderRadius: '30px' }}>
                                                <DropdownItem header={true}>EXPORT TO SPREADSHEET</DropdownItem>
                                                <a
                                                    href={AppConfig.apiUrl + '/report/orders-list/' + eventId}
                                                    style={{ textDecoration: 'none', width: '100%' }}
                                                >
                                                    <DropdownItem style={{ width: '100%' }}>
                                                        ALL CUSTOMER INFORMATION
                                                    </DropdownItem>
                                                </a>
                                                <a
                                                    href={AppConfig.apiUrl + '/report/guest-list/' + eventId}
                                                    style={{ textDecoration: 'none', width: '100%' }}
                                                >
                                                    <DropdownItem style={{ width: '100%' }}>
                                                        CUSTOMER NAME, TICKET ID
                                                    </DropdownItem>
                                                </a>
                                                <a
                                                    href={AppConfig.apiUrl + '/report/name-list/' + eventId}
                                                    style={{ textDecoration: 'none', width: '100%' }}
                                                >
                                                    <DropdownItem style={{ width: '100%' }}>
                                                        SALES BY TICKET TYPE
                                                    </DropdownItem>
                                                </a>
                                                <a
                                                    href={AppConfig.apiUrl + '/report/general-tickets/' + eventId}
                                                    style={{ textDecoration: 'none', width: '100%' }}
                                                >
                                                    <DropdownItem style={{ width: '100%' }}>
                                                        GENERAL TICKET SALES
                                                    </DropdownItem>
                                                </a>
                                                <a
                                                    href={AppConfig.apiUrl + '/report/promoter-tickets/' + eventId}
                                                    style={{ textDecoration: 'none', width: '100%' }}
                                                >
                                                    <DropdownItem style={{ width: '100%' }}>
                                                        PROMOTER TICKET SALES
                                                    </DropdownItem>
                                                </a>
                                                <a
                                                    href={AppConfig.apiUrl + '/report/referral-tickets/' + eventId}
                                                    style={{ textDecoration: 'none', width: '100%' }}
                                                >
                                                    <DropdownItem style={{ width: '100%' }}>
                                                        REFERRAL TICKET SALES
                                                    </DropdownItem>
                                                </a>
                                            </DropdownMenu>
                                        </Dropdown>
                                    </div>
                                </OnlyHost>
                            </div>

                        </div>
                        <div className="small-split-995" style={{ textAlign: 'center' }}>
                            <p />
                            <div
                                className='new-button-white-3'
                                onClick={e =>
                                    this.openDecayModal()
                                }
                                style={{ cursor: 'pointer', width: '110px' }}
                            >
                                VOID TICKETS
                                </div>
                        </div>
                        <p><br /></p>
                        <div style={{
                            overflowX: "scroll"
                        }}>
                            <table className='table-responsive--base m-0' style={{ minWidth: '900px' }}>
                                <thead>
                                    <tr>
                                        <td onClick={e => this.sort('customer')} style={{ cursor: 'pointer' }}>CUSTOMER</td>
                                        <td onClick={e => this.sort('status')} style={{ cursor: 'pointer' }}>STATUS</td>
                                        <td onClick={e => this.sort('price')} style={{ cursor: 'pointer' }}>PRICE</td>
                                        {this.props.isHost || this.props.user.roles.includes(RolesSystem.ADMIN) ? <td onClick={e => this.sort('promoter')} style={{ cursor: 'pointer' }}>PROMOTER</td> : null}
                                        <td onClick={e => this.sort('note')} style={{ cursor: 'pointer' }}>NOTE</td>
                                        <td onClick={e => this.sort('id')} style={{ cursor: 'pointer' }}>TICKET ID</td>
                                        <td>BOUGHT AT</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                            </table>
                            <div style={{ maxHeight: '400px' }}>
                                <table className='table-responsive--base' style={{ minWidth: '900px', overflowX: 'scroll' }}>
                                    <tbody>
                                        {/* for NON VOIDED TICKETS */}
                                        {this.state.loadingTickets ? null : tickets.length > 0 ? (
                                            tickets.map((ticket, index) => {
                                                if (ticket.status === 'cancelled') {
                                                    return null;
                                                }
                                                return (
                                                    <tr key={'ticket-item-' + ticket.code}>
                                                        <td data-label={'Customer'} className="sexyBlack">
                                                            {ticket.buyer ? ticket.buyer.fullName : '-'}
                                                        </td>
                                                        <td data-label={'Status'}>
                                                            <StatusBadge>{
                                                                ticket.status
                                                                || '-'}
                                                            </StatusBadge>
                                                        </td>
                                                        <td data-label={'Price'}>
                                                            {

                                                                currency === 'INR' ? <span>&#8377;{(this.countTicketPrice(ticket.ticketComponents) / 100).toFixed(2)} </span> : '$'
                                                                    + (this.countTicketPrice(ticket.ticketComponents) / 100).toFixed(2)
                                                            }
                                                        </td>
                                                        {
                                                            this.props.isHost || this.props.user.roles.includes(RolesSystem.ADMIN) ? (<td data-label={'Promoter'}>
                                                                {
                                                                    ticket.promoterId !== undefined &&
                                                                        ticket.promoterId !== null &&
                                                                        this.props.promMap !== undefined &&
                                                                        this.props.promMap[ticket.promoterId] !== undefined &&
                                                                        this.props.promMap[ticket.promoterId].name !== undefined &&
                                                                        this.props.promMap[ticket.promoterId].name !== null ?
                                                                        this.props.promMap[ticket.promoterId].name : '-'
                                                                }
                                                            </td>) : null
                                                        }
                                                        <td data-label={'Note'}>{ticket.note || '-'}</td>
                                                        <td data-label={'Ticket ID'}>
                                                            {
                                                                ticket.status === 'activated' ?
                                                                    <div>
                                                                        <a href={AppConfig.hostUrl + '/' + ticket.code} style={{
                                                                            textDecoration: 'underline'
                                                                        }}>
                                                                            {ticket.code}
                                                                        </a>
                                                                        {
                                                                            ticket.clicks && ticket.clicks !== null ?
                                                                                <div style={{ fontSize: '12px', color: '#4d5ae9' }}>
                                                                                    {ticket.clicks === 1 ? ticket.clicks + ' page view' : ticket.clicks + ' page views'}
                                                                                </div>
                                                                                : null
                                                                        }
                                                                    </div>
                                                                    : ticket.code
                                                            }
                                                        </td>
                                                        <td style={{ fontSize: '12px', textAlign: 'center' }}>
                                                            {
                                                                ticket.status === 'bought' || ticket.status === 'checkedIn' || ticket.status === 'partiallyCheckedIn' ?
                                                                    <span>
                                                                        <Moment format="M.D.Y">
                                                                            {ticket.boughtAt}
                                                                        </Moment>
                                                                        &nbsp;
                                                                        <Moment format="hh:mm A">
                                                                            {ticket.boughtAt}
                                                                        </Moment>
                                                                    </span> : '-'
                                                            }
                                                        </td>
                                                        <td data-label={''}>
                                                            <ButtonGroup>
                                                                {ticket.status === 'bought' ?
                                                                    <button
                                                                        onClick={e => this.openDetailModal(ticket)}
                                                                        className="new-button-white-4"
                                                                        style={{
                                                                            border: 'none'
                                                                        }}
                                                                    >
                                                                        DETAILS
                                                                    </button>
                                                                    : null}
                                                                {ticket.status === 'activated' ? (

                                                                    <button
                                                                        onClick={e =>
                                                                            this.decayTicket(ticket.code, index)
                                                                        }
                                                                        className="new-button-white-4"
                                                                        style={{
                                                                            border: 'none', color: '#FF5244'
                                                                        }}
                                                                    >
                                                                        VOID
                                                                    </button>
                                                                ) : null}
                                                            </ButtonGroup>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : null}

                                        {/* For VOIDED TICKETS */}
                                        {this.state.loadingTickets ? null : tickets.length > 0 ? (
                                            tickets.map((ticket, index) => {
                                                if (ticket.status !== 'cancelled') {
                                                    return null;
                                                }
                                                return (
                                                    <tr key={'ticket-item-' + ticket.code}>
                                                        <td data-label={'Customer'} className="sexyBlack">
                                                            {ticket.buyer ? ticket.buyer.fullName : '-'}
                                                        </td>
                                                        <td data-label={'Status'}>
                                                            <StatusBadge>{
                                                                ticket.status
                                                                || '-'}
                                                            </StatusBadge>
                                                        </td>
                                                        <td data-label={'Price'}>
                                                            {
                                                                ticket.status !== 'refunded' ?
                                                                    currency === 'INR' ? <span>&#8377;{(this.countTicketPrice(ticket.ticketComponents) / 100).toFixed(2)} </span> : '$'
                                                                        + (this.countTicketPrice(ticket.ticketComponents) / 100).toFixed(2)
                                                                    : <span style={{ color: '#d9534f' }}>{currency === 'INR' ? <span>
                                                                        &#8377;{(Number(ticket.totalProcessingFees) / 100).toFixed(2)}
                                                                    </span> : '-$' + (Number(ticket.totalProcessingFees) / 100).toFixed(2)}</span>
                                                            }
                                                        </td>
                                                        {
                                                            this.props.isHost || this.props.user.roles.includes(RolesSystem.ADMIN) ? (<td data-label={'Promoter'}>
                                                                {
                                                                    ticket.promoterId !== undefined &&
                                                                        ticket.promoterId !== null &&
                                                                        this.props.promMap !== undefined &&
                                                                        this.props.promMap[ticket.promoterId] !== undefined &&
                                                                        this.props.promMap[ticket.promoterId].name !== undefined &&
                                                                        this.props.promMap[ticket.promoterId].name !== null ?
                                                                        this.props.promMap[ticket.promoterId].name : '-'
                                                                }
                                                            </td>) : null
                                                        }
                                                        <td data-label={'Note'}>{ticket.note || '-'}</td>
                                                        <td data-label={'Ticket ID'}>
                                                            {
                                                                ticket.status === 'activated' ?
                                                                    <div>
                                                                        <a href={AppConfig.hostUrl + '/' + ticket.code} style={{
                                                                            textDecoration: 'underline'
                                                                        }}>
                                                                            {ticket.code}
                                                                        </a>
                                                                        {
                                                                            ticket.clicks && ticket.clicks !== null ?
                                                                                <div style={{ fontSize: '12px', color: '#4d5ae9' }}>
                                                                                    {ticket.clicks === 1 ? ticket.clicks + ' page view' : ticket.clicks + ' page views'}
                                                                                </div>
                                                                                : null
                                                                        }
                                                                    </div>
                                                                    : ticket.code
                                                            }
                                                        </td>
                                                        <td style={{ fontSize: '12px', textAlign: 'center' }}>
                                                            <Moment format="M.D.Y">
                                                                {ticket.boughtAt}
                                                            </Moment>
                                                            <Moment format="hh:mm A">
                                                                {ticket.boughtAt}
                                                            </Moment>
                                                        </td>
                                                        <td data-label={''}>
                                                            <ButtonGroup>
                                                                {/* <OnlyHost eventId={this.props.match.params.eventId}> */}
                                                                {ticket.status === 'bought' ?
                                                                    <button
                                                                        onClick={e => this.openDetailModal(ticket)}
                                                                        className="new-button-white-4"
                                                                        style={{
                                                                            border: 'none',
                                                                            color: '#4D5AE9'
                                                                        }}
                                                                    >
                                                                        DETAILS
                                                                    </button>
                                                                    : null}
                                                                {/* </OnlyHost> */}
                                                                {ticket.status === 'activated' ? (

                                                                    <button
                                                                        onClick={e =>
                                                                            this.decayTicket(ticket.code, index)
                                                                        }
                                                                        className="new-button-white-4"
                                                                        style={{
                                                                            border: 'none',
                                                                            color: '#FF5244'
                                                                        }}
                                                                    >
                                                                        VOID
                                                                    </button>
                                                                ) : null}
                                                            </ButtonGroup>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : null}
                                        {
                                            this.state.loadingTickets ? null : tickets.length === 0 ? (
                                                <tr>
                                                    <td colSpan={7}>No tickets.</td>
                                                </tr>
                                            ) : null
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ContentLoader>
                </div>
                <p />
            </Card>
        )
    }

}

const mapStateToProps = state => ({
    resendEmail: UserDucks.getResendEmail(state),
    user: UserDucks.getUser(state)
});

export default connect(mapStateToProps)(Orders)


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/Orders.tsx